// extracted by mini-css-extract-plugin
export default {"searchForm":"search_styles_searchForm__GAg0T","moveButtonWrapper":"search_styles_moveButtonWrapper__LCyvH","addNewAppButtonWrapper":"search_styles_addNewAppButtonWrapper__0P2zN"};